import { useEffect, useState } from "react";

import {
  getCurrentSubscriptionConnectionState,
  subscribeToSubscriptionConnectionState,
  type SubscriptionConnectionState,
} from "@/graphql/subscriptionClient";

export function useSubscriptionConnectionState(): SubscriptionConnectionState {
  const [state, setState] = useState<SubscriptionConnectionState>(
    getCurrentSubscriptionConnectionState(),
  );

  useEffect(() => subscribeToSubscriptionConnectionState(setState), []);

  return state;
}
